import { fetUserData } from '@/api/index'

const state = {
  userinfo: {},
}

const mutations = {
  SET_USER: (state, data) => {
    state.userinfo = data
  }
}

const actions = {
  getUserInfo({ commit }, data) {
    fetUserData({
      language: localStorage.getItem('lang') || 'CN'
    }).then((data)=>{
      console.log(data,'user')
      commit('SET_USER', data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js